import getConfigRequestUrl from "./getConfigRequestUrl";
import isLoyaltyAvailable from "./operations/isLoyaltyAvailable";
import isBenefitAvailableForTier from "./operations/isBenefitAvailableForTier";
import getCustomerDetails from "./operations/getCustomerDetails";
import setCustomerConsent from "./operations/setCustomerConsent";
import getCustomerTierId from "./operations/getCustomerTierId";
import getTierDetails from "./operations/getTierDetails";
import getConfig from "./operations/getConfig";
import sanitizeParams from "./sanitizeParams";
const sdk = (params) => {
    let initializePromise = null;
    let config = null;
    const sanitizedParams = sanitizeParams(params);
    const { asosWebRequest } = sanitizedParams;
    const initialize = () => {
        if (!initializePromise) {
            const url = getConfigRequestUrl(sanitizedParams);
            initializePromise = asosWebRequest
                .get({ url })
                .then((response) => {
                config = response.data;
            })
                .catch((error) => {
                initializePromise = null;
                throw error;
            });
        }
        return initializePromise;
    };
    return {
        initialize,
        isLoyaltyAvailable: () => isLoyaltyAvailable(config),
        isBenefitAvailableForTier: (tierId, benefitType) => isBenefitAvailableForTier(config, tierId, benefitType),
        getCustomerDetails: () => getCustomerDetails({ ...sanitizedParams, config }),
        setCustomerConsent: (consentStatus) => setCustomerConsent({ ...sanitizedParams, config, consentStatus }),
        getCustomerTierId: () => getCustomerTierId({ ...sanitizedParams, config }),
        getTierDetails: (tierId) => getTierDetails(config, tierId),
        getConfig: () => getConfig(config),
    };
};
export * from "./errors";
export default sdk;
